var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68425 43.0792H9.63775L9.59146 43.0833C9.14123 43.1235 8.45129 43.0252 7.90423 42.6346C7.41513 42.2852 6.90919 41.6113 6.90919 40.2019V14.4531H8.64258V40.2019V41.2435H9.68425H35.5015V43.0792H9.68425Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4124 29.5875H37.3554C37.6942 29.5875 37.9483 29.4323 38.1177 29.1217C38.2871 28.811 38.259 28.5146 38.0331 28.2321L33.3738 22.0056C33.2044 21.7798 32.9783 21.6669 32.696 21.6669C32.4135 21.6669 32.1877 21.7798 32.0183 22.0056L27.6131 27.8933L24.4788 23.7C24.3094 23.474 24.0833 23.361 23.801 23.361C23.5185 23.361 23.2927 23.474 23.1233 23.7L19.7347 28.2321C19.5088 28.5146 19.4806 28.811 19.65 29.1217C19.8194 29.4323 20.0736 29.5875 20.4124 29.5875ZM17.0238 36.3648C16.092 36.3648 15.294 36.0331 14.6298 35.3702C13.9668 34.706 13.6353 33.9081 13.6353 32.9762V9.2561C13.6353 8.32423 13.9668 7.52623 14.6298 6.86206C15.294 6.19902 16.092 5.86752 17.0238 5.86752H40.744C41.6758 5.86752 42.4738 6.19902 43.1379 6.86206C43.801 7.52623 44.1325 8.32423 44.1325 9.2561V32.9762C44.1325 33.9081 43.801 34.706 43.1379 35.3702C42.4738 36.0331 41.6758 36.3648 40.744 36.3648H17.0238Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteImage);
export default __webpack_public_path__ + "static/media/white-image.73981175dd39c8a6a1774c1079958f64.svg";
export { ForwardRef as ReactComponent };